import { useState } from "react";
import './tooltip.css';

interface TooltipProps {
  content: string;
  children: any;
}

export const Tooltip = ({ content, children }: TooltipProps) => {
  const [showTooltip, setShowTooltip] = useState<boolean>(false);

  const handleMouseEnter = () => {
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ position: "relative", display: "inline-block" }}
    >
      {children}
      {showTooltip && (
        <div className="tooltip-w">
          {content}
        </div>
      )}
    </div>
  );
};
